import React, { useState, useEffect } from 'react';
import { getBackendURL } from '../utils';
import { useAuth } from '../auth';
import { useNavigate } from 'react-router-dom';
import ProgressTabs from '../components/ProgressTabs';
import SweatTextTitle from '../steps/SweatTextTitle';
import RemindersInfo from './RemindersInfo';

import '../BasicReminder.css';

const Step6 = () => {
  const { user } = useAuth();
  const [smsHistory, setSmsHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const steps = ['Step 1', 'Step 2', 'Step 3', 'Step 4', 'Step 5', 'Step 6'];

  useEffect(() => {

    if (!user || !user.role.includes('trainer')) {
      alert('You must be a trainer to access this step. If you are indeed a trainer, please contact our Instagram for account support.');
      navigate('/tools/reminders/step1');
      return;
    }

  }, []);

  
  useEffect(() => {
    setLoading(true);
    fetch(getBackendURL() + `/sms_message?recipient_id=${encodeURIComponent(user?.user_id || '')}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${window.localStorage.getItem('ptc_access_token') || ''}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch SMS history');
        return res.json();
      })
      .then((data) => {
        setSmsHistory(data || []);
      })
      .catch((err) => console.error('Error fetching SMS history:', err))
      .finally(() => setLoading(false));
  }, [user?.user_id]);

  return (
    <div className="reminder-container fogged-card">
      <SweatTextTitle />
      <RemindersInfo />


      <ProgressTabs currentStep={5} />

      
      <h2 className="step-title">Step 6: Trainer setup is complete for now!</h2>
      <p>
        If you sent an invite email to your client, they should receive an email soon.
      </p>
      <p>
        You can view and edit the status 
        of your clients reminders on the dashboard!
      </p>
     


      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem' }}>
        <button className="ptc-secondary-button" onClick={() => navigate('/tools/reminders/step5')} style={{ padding: '1rem 2rem', fontSize: '1rem' }}>
          Previous Step
        </button>
        <button className="ptc-button" onClick={() => navigate('/tools/reminders/dashboard')} style={{ padding: '1rem 2rem', fontSize: '1rem' }}>
          Check out the Dashboard!
        </button>
      </div>
    </div>
  );
};

export default Step6;